export default "__VITE_ASSET__E5Eibx1Q__"